import {useQuery} from "@tanstack/react-query";
import {getList} from "../../../app/getters/getList.js";
import {useSelector} from "react-redux";


export const useProfile = (enabled = true) => {
    const role = useSelector(state => state.user.role);
    const roleParame = role === 'oper' ? 'oper' : '';
    return useQuery({
        queryKey: [`oper_profile`],
        queryFn: () => getList(`${roleParame}/profile/lista`),
        enabled: enabled,
    })
}